import { http } from './httpClient'
import type {
  EmailCodeResponse,
  LoginRequest,
  LoginResponse,
  MeResponse,
  PasswordResetConfirmRequest,
  PasswordResetRequest,
  RegisterRequest,
  RegisterResponse,
  VerifyEmailRequest,
} from './types'

export const authApi = {
  register: (body: RegisterRequest) =>
    http.post<RegisterResponse, RegisterRequest>('/api/auth/register/', body, {
      skipAuthRefresh: true,
    }),

  // `silent`: a 401 here means "wrong credentials", not "session expired" — the
  // global listener would otherwise answer it with a redirect back to /login.
  login: (body: LoginRequest) =>
    http.post<LoginResponse, LoginRequest>('/api/auth/login/', body, {
      skipAuthRefresh: true,
      silent: true,
    }),

  logout: () =>
    http.post<void>('/api/auth/logout/', undefined, { skipAuthRefresh: true }),

  refresh: () =>
    http.post<void>('/api/auth/refresh/', undefined, { skipAuthRefresh: true }),

  // `silent`: esta e a sondagem de sessao, chamada tambem por quem nunca fez
  // login. Um 401 aqui significa "visitante", nao "sessao expirou" — deixar o
  // listener global reagir jogava para /login quem abriu /register,
  // /forgot-password ou o link de recuperacao que chega por e-mail.
  // `loadMe()` ja traduz o 401 em `guest`, e o RequireAuth cuida do redirect
  // de quem realmente precisava estar logado.
  me: () => http.get<MeResponse>('/api/auth/me/', { silent: true }),

  updateMe: (body: { name?: string; email?: string; password?: string; current_password?: string }) =>
    http.patch<MeResponse, typeof body>('/api/auth/me/', body),

  verifyPassword: (password: string) =>
    http.post<void, { password: string }>('/api/auth/verify-password/', { password }),

  /** (Re)send the confirmation code to the signed-in user's address. */
  sendEmailCode: () => http.post<EmailCodeResponse>('/api/auth/email/send-code/'),

  verifyEmail: (code: string) =>
    http.post<MeResponse, VerifyEmailRequest>('/api/auth/email/verify/', { code }),

  // Recovery runs without a session: skip the refresh interceptor so a stale
  // cookie cannot turn a 4xx into a logout round-trip.
  requestPasswordReset: (email: string) =>
    http.post<EmailCodeResponse, PasswordResetRequest>(
      '/api/auth/password-reset/',
      { email },
      { skipAuthRefresh: true },
    ),

  confirmPasswordReset: (body: PasswordResetConfirmRequest) =>
    http.post<void, PasswordResetConfirmRequest>('/api/auth/password-reset/confirm/', body, {
      skipAuthRefresh: true,
    }),
}
